import React, { useState } from "react";
import { Formik, Form, Field, FieldArray } from "formik";
import performRequest from "../../api/request";
import { Toast } from "../../CustomComponent/toast";
import { useParams } from "react-router-dom";
import { FcPaid } from "react-icons/fc";
import StepRoutes from "../../Routes/steps_routes";
import SimpleButton from "../../Components/layouts/simple_button";
import { useRef } from "react";
import { useNavigate } from "react-router-dom";
import { FaChevronDown } from "react-icons/fa";
import { useEffect } from "react";
import { CustomErrorResponse } from "../../CustomComponent/custom_error_response";

const EditEpgRecipe = () => {
  const [hasVariants, setHasVariants] = useState(false);
  const fileInputRef = useRef(null);
  const { id } = useParams();

  const navigate = useNavigate();
  let [data, setData] = useState([]);

  const [initialValues, setInitialValues] = useState({
    title: "",
    subtitle: "",
    description: "",
    variants: [],
    images: [],
    image: "",
    status: "active",
    tags: "",
    quantity: 0,
  });

  useEffect(() => {
    getRecipe();
    getVariants();
  }, []);

  const getRecipe = async () => {
    try {
      const res = await performRequest("GET", `/pmg/recipes/get-recipe/${id}`);

      if (res.status === 200) {
        const recipe = res.data.data;

        setHasVariants(recipe.variants?.length > 0);

        setInitialValues({
          title: recipe.title || "",
          subtitle: recipe.subtitle || "",
          description: recipe.description || "",
          status: recipe.status || "active",
          tags: recipe.tags || "",
          image: "",
          images: recipe.images || [],
          quantity: recipe.quantity || 0,
          variants:
            recipe.variants?.map((item) => ({
              id: item.id,
              product_variant_id: item.product_variant_id,
              quantity: item.quantity,
            })) || [],
        });
      }
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  const getVariants = async () => {
    try {
      const res = await performRequest("GET", "/pmg/varient/product-varient");

      setData(res.data.data || []);
    } catch (err) {
      CustomErrorResponse(err);
    }
  };

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const formattedValues = {
        ...values,
      };

      // Default variant if no variants
      if (!hasVariants || values.variants.length === 0) {
        formattedValues.variants = [
          {
            title: values.title,
          },
        ];
      }

      const formData = new FormData();

      formData.append("recipe", JSON.stringify(formattedValues));

      // Main image
      if (values.image) {
        formData.append("image", values.image);
      }

      // Gallery images
      if (values.images?.length > 0) {
        values.images.forEach((file) => {
          formData.append("images", file);
        });
      }

      const res = await performRequest(
        "PATCH",
        `/pmg/recipes/update-recipe/${id}`,
        formData
      );

      if (res.status === 200) {
        
        Toast("success", "Recipe Updated successfully!");
        navigate(`/all-epg-recipe`);
        resetForm();
      } else {
        Toast("error", "Error updaing product!");
      }
    } catch (err) {
      console.error(err);
      Toast("error", "Server error while creating recipe!");
    } finally {
      setSubmitting(false);
    }
  };

  const getImageSrc = (img) => {
    if (!img) return "";

    // If already URL (API image)
    if (typeof img === "string") return img;

    // If file (new upload)
    if (img instanceof File) return URL.createObjectURL(img);

    return "";
  };

  return (
    <div className="container-xl py-4">
      <div className="page-header d-print-none">
        <div className="row g-2 align-items-center">
          <div className="col">
            <h2 className="page-title mb-1">
              <FcPaid /> Edit EPG Recipe
            </h2>
            <h4 className="text-muted">
              <StepRoutes />
            </h4>
          </div>
        </div>
      </div>

      <div className="card my-4 p-4">
        <div className="card-header mb-5 py-3 fs-2 border d-flex justify-content-center">
          <h2>EDIT EPG RECIPE</h2>
        </div>

        <Formik
          enableReinitialize
          initialValues={initialValues}
          onSubmit={handleSubmit}
        >
          {({ values, touched, setFieldValue, isSubmitting, errors }) => {
            return (
              <Form>
                {/* Product Name */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">Recipe Title</label>
                  <div className="w-100 col">
                    <Field name="title" className="form-control" />
                    {touched.title && errors.title && (
                      <p className="text-danger">{errors.title}</p>
                    )}
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Recipe Subtitle
                  </label>
                  <div className="w-100 col">
                    <Field name="subtitle" className="form-control" />
                    {touched.subtitle && errors.subtitle && (
                      <p className="text-danger">{errors.subtitle}</p>
                    )}
                  </div>
                </div>

                {/* Description */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Recipe Description
                  </label>
                  <div className="w-100 col">
                    <Field
                      as="textarea"
                      name="description"
                      className="form-control"
                    />
                    {touched.description && errors.description && (
                      <p className="text-danger">{errors.description}</p>
                    )}
                  </div>
                </div>

                {/* Main Image */}
                <div className="mb-3 row">
                  <label className="col-3 form-label fs-3">
                    Inventory Recipe Image
                  </label>
                  <div className="col">
                    <input
                      id="imageInvInput"
                      type="file"
                      className="form-control"
                      onChange={(e) =>
                        setFieldValue("image", e.target.files[0])
                      }
                    />
                  </div>
                </div>

                {/* Multiple Images */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Recipe All Images
                  </label>
                  <div className="w-100 col">
                    <input
                      type="file"
                      multiple
                      className="form-control"
                      //   onChange={(e) => {
                      //     const files = Array.from(e.target.files);

                      //     const readers = files.map(
                      //       (file) =>
                      //         new Promise((resolve) => {
                      //           const reader = new FileReader();
                      //           reader.onloadend = () =>
                      //             resolve({
                      //               src: reader.result,
                      //               alt: file.name,
                      //             });
                      //           reader.readAsDataURL(file);
                      //         })
                      //     );

                      //     Promise.all(readers).then((imgs) =>
                      //       setFieldValue("images", [...values.images, ...imgs])
                      //     );
                      //   }}
                      onChange={(e) => {
                        const files = Array.from(e.target.files);
                        setFieldValue("images", [...values.images, ...files]);
                      }}
                    />
                    <div className="d-flex flex-wrap gap-3 mt-3 border">
                      {values.images.map((img, index) => (
                        <div key={index} className="border p-2">
                          <img
                            src={getImageSrc(img)}
                            alt="preview"
                            style={{
                              width: 100,
                              height: 100,
                              objectFit: "cover",
                            }}
                          />

                          <br />

                          <button
                            type="button"
                            className="btn btn-danger btn-sm mt-2"
                            onClick={() => {
                              const updated = values.images.filter(
                                (_, i) => i !== index
                              );
                              setFieldValue("images", updated);

                              if (fileInputRef.current) {
                                fileInputRef.current.value = "";
                              }
                            }}
                          >
                            Remove
                          </button>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>

                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">Quantity</label>
                  <div className="w-100 col">
                    <Field name="quantity" className="form-control" />
                    {touched.quantity && errors.quantity && (
                      <p className="text-danger">{errors.quantity}</p>
                    )}
                  </div>
                </div>

                {/* Variant Toggle */}
                <div className="mb-3 row">
                  <label className="w-25 form-label fs-3">
                    Add Recipe Products
                  </label>

                  <div className="w-100 col">
                    <input
                      type="checkbox"
                      className="form-check-input"
                      style={{ width: 25, height: 25 }}
                      checked={hasVariants}
                      onChange={(e) => setHasVariants(e.target.checked)}
                    />
                  </div>
                </div>

                {/* Variants */}
                {hasVariants && (
                  <FieldArray name="variants">
                    {({ remove, push }) => (
                      <div>
                        {values.variants.map((variant, index) => (
                          <div key={index} className="border rounded p-4 mb-3">
                            <div className="row g-3">
                              {/* <div className="col-md-2">
                                <label>Variant Title</label>
                                <Field
                                  name={`variants.${index}.title`}
                                  className="form-control"
                                  placeholder="Enter Variant Title"
                                />
                              </div> */}
                              <div className="col-md-8">
                                <label className="mb-2">Select Product</label>

                                <Field
                                  as="select"
                                  name={`variants.${index}.product_variant_id`}
                                  className="form-control"
                                >
                                  <option value="">
                                    Select Recipe Product
                                  </option>

                                  {data.map((item) => (
                                    <option key={item.id} value={item.id}>
                                      {item.pmg_product?.title} ({item.title})
                                    </option>
                                  ))}
                                </Field>
                              </div>
                              {/* <div className="col-md-2">
                                <label>Price</label>
                                <Field
                                  name={`variants.${index}.price`}
                                  type="number"
                                  className="form-control"
                                  placeholder="Enter Price"
                                />
                              </div>
                              <div className="col-md-2">
                                <label>Barcode</label>
                                <Field
                                  name={`variants.${index}.barcode`}
                                  className="form-control"
                                  placeholder="Enter Barcode"
                                />
                              </div> */}
                              <div className="col-md-2">
                                <label className="mb-2">Quantity</label>
                                <Field
                                  name={`variants.${index}.quantity`}
                                  type="number"
                                  className="form-control"
                                  //   placeholder="Enter Quantity"
                                  //   value={values.variants[index].quantity || 1}
                                />
                              </div>

                              {/* <div className="col-md-2 position-relative">
                                <label>Unit</label>

                                <Field
                                  as="select"
                                  name={`variants.${index}.unit`}
                                  className="form-control pr-4"
                                >
                                  <option value="">select</option>
                                  <option value="pcs">pcs</option>
                                  <option value="kg">kg</option>
                                  <option value="g">g</option>
                                  <option value="ltr">ltr</option>
                                  <option value="nos">nos</option>
                                  <option value="ml">ml</option>
                                </Field>

                      
                                <FaChevronDown
                                  style={{
                                    position: "absolute",
                                    right: "15px",
                                    top: "38px",
                                    fontSize: "12px",
                                    color: "#666",
                                    pointerEvents: "none",
                                  }}
                                />
                              </div> */}
                              <div className="col-md-2">
                                <div className="text-end mt-3">
                                  <button
                                    type="button"
                                    className="btn btn-danger"
                                    onClick={() => remove(index)}
                                  >
                                    Remove
                                  </button>
                                </div>
                              </div>
                            </div>
                          </div>
                        ))}

                        <button
                          type="button"
                          className="btn btn-outline-success mb-3"
                          onClick={() =>
                            push({
                              product_variant_id: "",
                              quantity: 1,
                            })
                          }
                        >
                          + Add Product
                        </button>
                      </div>
                    )}
                  </FieldArray>
                )}

                {/* Submit */}
                <div className="card-footer">
                  <div className="btn-list justify-content-end">
                    <button
                      type="submit"
                      className="btn btn-primary mx-1 mt-2"
                      disabled={isSubmitting}
                    >
                      {isSubmitting ? "Saving..." : "Edit Recipe"}
                    </button>

                    <SimpleButton buttonText="Cancel" type="secondary" />
                  </div>
                </div>
              </Form>
            );
          }}
        </Formik>
      </div>
    </div>
  );
};

export default EditEpgRecipe;
